export type IRemoveObjectPropByKey = (
  object: IDCA.IGenericObj,
  property: string
) => IDCA.IGenericObj;

export function removeObjectPropByKey(
  object: IDCA.IGenericObj,
  property: string
): IDCA.IGenericObj {
  const cleanObj = { ...object };

  function remove(data: IDCA.IGenericObj) {
    Object.keys(data).forEach(key => {
      const item = data[key];
      //  If this item is an object, then recurse into it
      if (typeof item === 'object') {
        remove(item);
      } else if (key === property) {
        //  see if this is the key we are looking for
        delete data[key];
      }
    });
  }

  remove(cleanObj);
  return cleanObj;
}
